<template>
    <div>
        <app-gridview
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>

<script>
import moment from 'moment';

import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },  
    
    data() {
        return {
            pageTitle: this.$t('arrearsexercise.arrearsexercise'),
            dataHeader: [
                {text: this.$t('columns.actions'), value: 'action', sortable: false,width:'80px'},
                {text: this.$t('arrearsexercise.bpexercisecode'), value: 'bpexercisecode', width: '150px'},
                {text: this.$t('arrearsexercise.bpexercisedesc'), value: 'bpexercisedesc', width: '250px'},
                {text: this.$t('arrearsexercise.inceffdate'), value: 'inceffdate', width: '130px'},
                {text: this.$t('arrearsexercise.actinceffdate'), value: 'actinceffdate', width: '130px'},
                {text: this.$t('arrearsexercise.posted'), value: 'posted', width: '100px'},
                {text: this.$t('arrearsexercise.posttopayout'), value: 'posttopayout', width: '100px'},
                {text: this.$t('arrearsexercise.posttopayoutdesc'), value: 'posttopayoutdesc', width: '150px'}
            ],
            dataItems: [],
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {
        loadArrearsExercises() {
            const vm = this;

            this.$store.dispatch('get', {url: '/arrearsexercise/all'})
            .then(res => {
                vm.dataItems = res.data.rec;

                for (let i = 0; i < vm.dataItems.length; i++) {
                    vm.dataItems[i].posted = vm.dataItems[i].posted ? 'Y' : 'N';

                    if (vm.dataItems[i].inceffdate) {
                        vm.dataItems[i].inceffdate = moment(vm.dataItems[i].inceffdate).format('YYYY-MM-DD');
                    }

                    if (vm.dataItems[i].actinceffdate) {
                        vm.dataItems[i].actinceffdate = moment(vm.dataItems[i].actinceffdate).format('YYYY-MM-DD');
                    }
                }
            })
            .catch(err => {
                vm.errMsg = err;
            });
        },

        editItemHandler(item) {
            this.$router.push({name: 'arrearsexerciseedit', params: { id: item.id, search: item.search } });
        },

        newRecordHandler() {
            this.$router.push({name: 'arrearsexercisenew'});
        }
    },

    mounted() {
        this.loadArrearsExercises();
    }
}
</script>